module.exports = __webpack_public_path__ + "static/media/digitalPrototype.64428979.jpg";